export class SetNotebookPhotos {
    public static readonly type = "[Projects] Set notebook photos";

    constructor(public payload: number) {}
}
